/**
 * 系统全局变量定义
 * @type {{}}
 */
export default {
    //面包屑
    breadcrumb:null,
    token:null,
};
